<div class="video-episodes-area pt-75 pb-75" *ngIf="learnVideos?.length">
  <div class="container">
    <div class="section-title d-flex align-items-center justify-content-between">
      <h2 class="heading-title">AfroTech Learn</h2>
      <a routerLink="/afrotech-learn" *ngIf="learnVideos.length > 1">
        Apprenez un concept en moins de 3min <i class="ri-arrow-right-s-line"></i>
      </a>
    </div>

    <div class="row align-items-stretch">
      <!-- Vidéo principale -->
      <div [ngClass]="learnVideos.length > 1 ? 'col-lg-6 col-md-12' : 'col-12'">
        <app-youtube-lazy
          [videoId]="firstVideo?.videoId"
          [title]="firstVideo?.title"
          class="rounded"
        ></app-youtube-lazy>
        <div class="video-info mt-2 mb-2">
          <span class="fw-semibold">{{ firstVideo?.title }}</span>
          <span class="text-muted small d-block mt-1">{{ firstVideo?.date | date: 'mediumDate' }}</span>
        </div>
      </div>

      <!-- Vidéos secondaires -->
      <div class="col-lg-6 col-md-12" *ngIf="learnVideos.length > 1">
        <div class="video-episodes-right-card">
          <div class="items-card">
            <div class="item-box" *ngFor="let video of learnVideos.slice(1, 4)">
              <div class="row align-items-center">
                <div class="col-4">
                  <app-youtube-lazy
                    [videoId]="video.videoId"
                    [title]="video.title"
                    class="rounded"
                  ></app-youtube-lazy>
                </div>
                <div class="col-8">
                  <div class="right-info">
                    <span class="text-info small d-block mb-1">
                      {{ video.date | date: isToday(video.date) ? 'shortTime' : 'd MMM y' }}
                    </span>
                    <h4 class="title mb-1">
                      <a [href]="'https://www.youtube.com/watch?v=' + video.videoId" target="_blank">
                        {{ video.title }}
                      </a>
                    </h4>
                    <p class="mb-0 text-white-50 small">Durée : {{ video.duration }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>